// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"036dc71a","455":"7d188476","977":"c9ab7f8f"}[chunkId] + ".chunk.js";
};